export default __webpack_public_path__ + "static/media/Ogapharmacy Logo.5ee5c3f5.png";